export const nestDeepChild = (arr, data) =>
  arr.map((typi) =>
    typi.id === data.data.typification_id
      ? {
          ...typi,
          children: typi.children.map((child) =>
            child.id === data.data.id
              ? {
                  ...child,
                  queue_id: typi.queue_id,
                  children: data.data.descendants.map(
                    ({ descendants, ...deepChild }) => ({
                      ...deepChild,
                      queue_id: typi.queue_id,
                      children: descendants
                        ? renameDescendantsAndNestQueue(typi.queue_id)(descendants)
                        : [{ name: "Loading" }],
                    })
                  ),
                }
              : child
          ),
        }
      : typi
  );

const renameDescendantsAndNestQueue = (queue_id) => (arr) =>
  arr.map(({ descendants, ...el }) =>
    descendants
      ? {
          ...el,
          children: renameDescendantsAndNestQueue(queue_id)(descendants),
          queue_id,
        }
      : { ...el, queue_id }
  );
